import { useMemo } from 'react';

import { Stack, Typography } from '@mui/material';
import { Icon } from 'components-new';
import { Game, ScoreType } from '@/_models/Game';

type Props = {
  scoreType: ScoreType;
  game: Game;
  gamePoints: number;
};

export const Points = ({ scoreType, game, gamePoints }: Props) => {
  const progress = useMemo(
    () =>
      `${gamePoints} / ${game?.locks?.reduce((acc, lock) => {
        return acc + (lock?.point || 0);
      }, 0)}`,
    [gamePoints, game?.locks],
  );

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Icon icon="fa-star" />
      <Typography variant="h6" noWrap>
        {scoreType === ScoreType.Points ? gamePoints : progress}
      </Typography>
    </Stack>
  );
};
